import React from "react";
import { Link } from "react-router-dom";
import {
  FaHome,
  FaShieldAlt,
  FaUsers,
  FaGift,
  FaBolt,
} from "react-icons/fa";

const AuthLeftBanner = ({ currentView }) => {
  const getBannerDetails = () => {
    switch (currentView) {
      case "register":
        return {
          heading: "Join EwRealty Today",
          desc: "Create your account to buy, sell or rent properties easily and securely.",
          features: [
            {
              icon: <FaHome />,
              title: "Verified Listings",
              sub: "100% genuine properties",
            },
            {
              icon: <FaShieldAlt />,
              title: "Trusted Platform",
              sub: "Safe and secure experience",
            },
            {
              icon: <FaGift />,
              title: "Exclusive Offers",
              sub: "Personalized property recommendations",
            },
            {
              icon: <FaBolt />,
              title: "Easy & Fast",
              sub: "Connect directly with owners",
            },
          ],
        };
      case "otp":
        return {
          heading: "Your Trusted Property Partner",
          desc: "Buy, Sell or Rent properties with confidence on EwRealty.",
          features: [
            {
              icon: <FaHome />,
              title: "Verified Listings",
              sub: "Genuine & verified properties",
            },
            {
              icon: <FaShieldAlt />,
              title: "Safe & Secure",
              sub: "Your data is always protected",
            },
            {
              icon: <FaUsers />,
              title: "Easy & Fast",
              sub: "Connect directly with owners",
            },
          ],
        };
      case "login":
      default:
        return {
          heading: "Find Your Dream Property",
          desc: "Buy, Sell or Rent properties with EwRealty.",
          features: [
            {
              icon: <FaHome />,
              title: "Verified Listings",
              sub: "Genuine & verified properties",
            },
            {
              icon: <FaShieldAlt />,
              title: "Trusted Platform",
              sub: "Safe and secure experience",
            },
            {
              icon: <FaUsers />,
              title: "Easy & Fast",
              sub: "Connect directly with owners",
            },
          ],
        };
    }
  };

  const banner = getBannerDetails();

  return (
    <div className="mgh-auth-banner">
      <div className="mgh-auth-dots-pattern" />

      <div>
        <Link to="/" className="mgh-auth-brand-header">
          <img
            src="/assets/images/white-logo1.png"
            alt="EwRealty Logo"
            className="mgh-auth-brand-logo-img"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/assets/images/logo.png";
            }}
          />
        </Link>

        <div className="mgh-auth-banner-content">
          <h1 className="mgh-auth-banner-heading">{banner.heading}</h1>
          <p className="mgh-auth-banner-desc">{banner.desc}</p>
        </div>

        <div className="mgh-auth-features">
          {banner.features.map((feat, idx) => (
            <div key={idx} className="mgh-auth-feature-item">
              <div className="mgh-auth-feature-icon">{feat.icon}</div>
              <div className="mgh-auth-feature-text">
                <span className="mgh-auth-feature-title">{feat.title}</span>
                <span className="mgh-auth-feature-sub">{feat.sub}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mgh-auth-banner-image-box">
        <img
          src="/assets/images/auth_banner_house.jpg"
          alt="Luxury Architecture Property"
          className="mgh-auth-banner-img"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/assets/images/why_choose_villa.jpg";
          }}
        />
      </div>

      <div className="mgh-auth-quote-tag">
        <div className="mgh-auth-quote-text">
          &ldquo;A better place to find your next home.&rdquo;
        </div>
        <div className="mgh-auth-quote-line" />
      </div>
    </div>
  );
};

export default AuthLeftBanner;
